import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router';
import { useAppContext } from '../context/AppContext';

export function useSticky(ref, stickyOffset = 0) {
    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const element = ref.current;
        if (!element) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                const isElementSticky = entry.boundingClientRect.top <= stickyOffset;
                setIsSticky(isElementSticky);
            },
            { threshold: 0 },
        );

        observer.observe(element);

        return () => observer.disconnect();
    }, [ref, stickyOffset]);

    return isSticky;
}

// support for viewing help center in foxtel app
export function useIsWrapper() {
    const { isWrapper, setIsWrapper } = useAppContext();
    const [searchParams] = useSearchParams();
    const isWrapperParam =
        searchParams.get('isWrapper') && searchParams.get('isWrapper')?.toLowerCase();
    const isWrapperParamLocalStorage =
        localStorage.getItem('isWrapper') && localStorage.getItem('isWrapper')?.toLowerCase();

    useEffect(() => {
        // prioritize query params over local storage
        if (isWrapperParam) {
            if (isWrapperParam === 'true') {
                localStorage.setItem('isWrapper', true);
                setIsWrapper(true);
            }
            if (isWrapperParam === 'false') {
                localStorage.setItem('isWrapper', false);
                setIsWrapper(false);
            }
        } else {
            if (isWrapperParamLocalStorage) {
                if (isWrapperParamLocalStorage === 'true') {
                    setIsWrapper(true);
                }

                if (isWrapperParamLocalStorage === 'false') {
                    setIsWrapper(false);
                }
            } else {
                setIsWrapper(false);
            }
        }
    }, [isWrapperParam]);

    return { isWrapper };
}
